const RECORDING_V1_PATH = '/api/v1/recording';
const RECORDING_V2_PATH = '/api/v2/recording';

export const RECORDINGS_PATH = RECORDING_V2_PATH;
export const RECORDING_PATH = `${RECORDING_V2_PATH}/:recordingId`;
export const RECORDING_DETAIL_PATH = `${RECORDING_V1_PATH}/:recordingId`;
